// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---B3efE","changedRecordsList":"changedRecordsList---YWiEi","changedRecord":"changedRecord---MJqgi"};